


































import Vue, { PropOptions } from 'vue'
import HeaderSection from './HeaderSection.vue'
import { IndustryValue } from '@/search/types'
import { MutationTypes } from '@/search/store'
import FilterItem from './FilterItem.vue'

export default Vue.extend({
  components: {
    HeaderSection,
    FilterItem
  },
  props: {
    industries: {
      type: Array,
      required: true
    } as PropOptions<IndustryValue[]>,
    industryValues: {
      type: Array,
      required: true
    } as PropOptions<number[]>,
    open: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    toggleSection: boolean
  } {
    return {
      toggleSection: this.open
    }
  },
  computed: {
    selectedIndustries: {
      get(): number[] {
        return this.industryValues
      },
      set(val: number[]) {
        const name = val.length === 1 ? this.industries.find(item => item.id === val[0])?.industryName : ''
        this.$emit('onSearchIndustries', {
          ids: val,
          name: name
        })
      }
    }
  },
  created() {
    if (this.selectedIndustries.length > 1) this.toggleSection = true
  },
  methods: {
    toggleSectionHandler(value: { [key: string]: boolean }) {
      this.toggleSection = value.toggle
      this.$emit('toggleSection', {
        toggle: value.toggle,
        id: MutationTypes.SET_OPEN_INDUSTRY_FILTER
      })
    }
  }
})
